import React, { Suspense, lazy, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setRedirectUrl } from "store/actions/authActions";
import { QueryParamProvider } from "use-query-params";

const PrivateRoutes = lazy(() => import("./PrivateRoutes"));
const Redirector = lazy(() => import("./Redirector"));
const Login = lazy(() => import("pages/Login"));
const Logout = lazy(() => import("pages/Logout"));
const NotFound = lazy(() => import("./NotFound"));
const SentryTest = lazy(() => import("./SentryTest"));
const Splash = lazy(() => import("shared/SplashScreen/Splash"));
const UrlRedirector = lazy(() => import("pages/UrlRedirector"));
const MaintenanceMode = lazy(() => import("shared/MaintenanceMode"));
const LimitedAccess = lazy(() => import("pages/LimitedAccess"));
const Password = lazy(() => import("pages/Password"));
const SessionTimeout = lazy(() => import("pages/SessionTimeout"));
const ExternalDocumentUnlock = lazy(
  () => import("pages/ExternalDocumentUnlock")
);
//const EmailVerification = lazy(() => import("pages/EmailVerification"));

const AppRoutes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn, redirectUrl, accounts } = useSelector(
    state => state.auth
  );

  useEffect(() => {
    if (isLoggedIn) {
      if (redirectUrl && !redirectUrl.includes("logout")) {
        navigate(redirectUrl);
        dispatch(setRedirectUrl(null));
      } else if (window.location.href.includes("/login")) {
        navigate("/mailboxes");
      }
    }
    // eslint-disable-next-line
  }, [isLoggedIn, accounts]);

  return (
    <Suspense fallback={<Splash />}>
      <QueryParamProvider ReactRouterRoute={Route}>
        <Routes>
          <Route path="/" element={<Redirector />} />
          <Route path="/login" element={<Login />} />
          <Route path="/maintenance/:type?" element={<MaintenanceMode />} />
          <Route path="/cpui/:type/:url" element={<UrlRedirector />} />
          <Route
            path="/documents/cp/d/:hash"
            element={<ExternalDocumentUnlock />}
          />
          <Route path="/logout" element={<Logout />} />
          <Route path="/password" element={<Password />} />
          <Route path="/limited/:token" element={<LimitedAccess />} />
          <Route path="/timeout" element={<SessionTimeout />} />
          {/*<Route path="/verify/:token" element={<EmailVerification />} />*/}
          <Route path="/sentry-test" element={<SentryTest />} />

          <Route
            path="*"
            element={isLoggedIn ? <PrivateRoutes /> : <NotFound />}
          />
        </Routes>
      </QueryParamProvider>
    </Suspense>
  );
};

export default AppRoutes;
